import React from 'react';

import {RecaptchaProvider} from '../components/ReCaptcha/RecaptchaProvider';
import {RemoteConfigProvider} from '../contexts/RemoteConfigContext';
import Switch from '../routes';

function App() {
  return (
    <RemoteConfigProvider>
      <RecaptchaProvider>
        <Switch />
      </RecaptchaProvider>
    </RemoteConfigProvider>
  );
}

export default App;
